/* ModeHaus theme — storefront behaviour */
(function () {
  'use strict';

  function formatMoney(cents, format) {
    var fmt = format || window.ModeHaus && window.ModeHaus.moneyFormat || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, withCommas)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withCommas.replace(/,/g, '.') + ',' + parts[1])
      .replace(/\{\{\s*amount\s*\}\}/, withCommas + '.' + parts[1]);
  }

  /* ---------- Cart count ---------- */
  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count < 1;
    });
    document.querySelectorAll('[data-cart-link]').forEach(function (el) {
      el.setAttribute('aria-label', 'Bag, ' + count + (count === 1 ? ' item' : ' items'));
    });
  }

  function showToast() {
    var toast = document.getElementById('CartToast');
    if (!toast) return;
    toast.hidden = false;
    clearTimeout(showToast._t);
    showToast._t = setTimeout(function () { toast.hidden = true; }, 4000);
  }

  /* ---------- Product form ---------- */
  function initProduct(root) {
    var dataEl = root.querySelector('[data-product-json]');
    if (!dataEl) return;
    var product = JSON.parse(dataEl.textContent);
    var form = root.querySelector('form[data-product-form]');
    var idInput = form.querySelector('input[name="id"]');
    var priceEl = root.querySelector('[data-product-price]');
    var addBtn = form.querySelector('[data-add-button]');
    var errorEl = root.querySelector('[data-product-error]');
    var moneyFormat = root.getAttribute('data-money-format');

    function selectedOptions() {
      return Array.prototype.map.call(root.querySelectorAll('[data-option-index]'), function (fs) {
        var checked = fs.querySelector('input:checked');
        var label = fs.querySelector('[data-selected-value]');
        if (checked && label) label.textContent = checked.value;
        return checked ? checked.value : null;
      });
    }

    function findVariant(opts) {
      return product.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }

    function markAvailability(opts) {
      root.querySelectorAll('[data-option-index]').forEach(function (fs) {
        var idx = parseInt(fs.getAttribute('data-option-index'), 10);
        fs.querySelectorAll('input').forEach(function (input) {
          var test = opts.slice();
          test[idx] = input.value;
          var match = findVariant(test);
          input.classList.toggle('is-unavailable', !match || !match.available);
        });
      });
    }

    function update() {
      var opts = selectedOptions();
      var variant = findVariant(opts);
      markAvailability(opts);
      if (!variant) {
        addBtn.disabled = true;
        addBtn.textContent = 'Unavailable';
        return;
      }
      idInput.value = variant.id;
      addBtn.disabled = !variant.available;
      addBtn.textContent = variant.available ? addBtn.getAttribute('data-label') : 'Sold out';
      if (priceEl) {
        var html = '';
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          html = '<span class="visually-hidden">Sale price</span><span class="price__current">' + formatMoney(variant.price, moneyFormat) +
            '</span><span class="visually-hidden">Regular price</span><s class="price__compare">' + formatMoney(variant.compare_at_price, moneyFormat) + '</s>';
          priceEl.classList.add('price--sale');
        } else {
          html = '<span class="price__current">' + formatMoney(variant.price, moneyFormat) + '</span>';
          priceEl.classList.remove('price--sale');
        }
        priceEl.innerHTML = html;
      }
      if (variant.featured_media) {
        var mediaEl = root.querySelector('[data-media-id="' + variant.featured_media.id + '"]');
        if (mediaEl && mediaEl.parentNode && mediaEl !== mediaEl.parentNode.firstElementChild) {
          mediaEl.parentNode.insertBefore(mediaEl, mediaEl.parentNode.firstElementChild);
        }
      }
      if (window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    root.querySelectorAll('[data-option-index] input').forEach(function (input) {
      input.addEventListener('change', update);
    });
    if (root.querySelector('[data-option-index]')) update();

    form.addEventListener('submit', function (e) {
      if (!window.fetch) return;
      e.preventDefault();
      if (errorEl) errorEl.hidden = true;
      addBtn.disabled = true;
      fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form)
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.data.description || res.data.message || 'Could not add to bag.');
          return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          updateCartCount(cart.item_count);
          showToast();
        })
        .catch(function (err) {
          if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
        })
        .finally(function () {
          addBtn.disabled = false;
          update();
        });
    });
  }

  /* ---------- Quantity buttons (cart) ---------- */
  function initQty() {
    document.querySelectorAll('[data-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      wrap.querySelectorAll('button').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = btn.getAttribute('data-step') === 'up' ? 1 : -1;
          input.value = Math.max(0, (parseInt(input.value, 10) || 0) + step);
          var form = input.form;
          if (form) form.submit();
        });
      });
    });
  }

  /* ---------- Product recommendations ---------- */
  function initRecommendations() {
    document.querySelectorAll('[data-recommendations-url]').forEach(function (el) {
      fetch(el.getAttribute('data-recommendations-url'))
        .then(function (r) { return r.text(); })
        .then(function (text) {
          var html = document.createElement('div');
          html.innerHTML = text;
          var fresh = html.querySelector('[data-recommendations-url]');
          if (fresh && fresh.innerHTML.trim().length) el.innerHTML = fresh.innerHTML;
        })
        .catch(function () {});
    });
  }

  /* ---------- Sort select ---------- */
  function initSort() {
    document.querySelectorAll('[data-sort]').forEach(function (select) {
      select.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', select.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    });
  }

  /* ---------- Drawer: close on Escape ---------- */
  function initDrawer() {
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('details.menu-drawer[open]').forEach(function (d) {
        d.removeAttribute('open');
        var s = d.querySelector('summary');
        if (s) s.focus();
      });
    });
    document.querySelectorAll('[data-drawer-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var d = btn.closest('details');
        if (d) d.removeAttribute('open');
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-product]').forEach(initProduct);
    initQty();
    initRecommendations();
    initSort();
    initDrawer();
  });
})();
